export const MessageBig = ({ message }: { message: string }) => {
  return (
    <>
      <div className="d-flex justify-content-center mb-2" style={{ marginTop: '200px', marginBottom: '200px' }}>
        <h2>{message}</h2>
      </div>
    </>
  );
};
